import script from "./web-expert-consultant-detail.vue?vue&type=script&setup=true&lang=js"
export * from "./web-expert-consultant-detail.vue?vue&type=script&setup=true&lang=js"

import "./web-expert-consultant-detail.vue?vue&type=style&index=0&id=685ed274&lang=scss"

const __exports__ = script;

export default __exports__